import { Collection } from "@tblabs/truffle";
import { Preset } from "./Preset";
import { PresetsStorage } from "./PresetsStorage";


export class PresetsProvider
{
    public Presets = new Collection<Preset>();

    constructor(private _storage: PresetsStorage)
    {
        const fromStorage = _storage.LoadAll();

        fromStorage.forEach(p => this.Presets.Add(p));
    }

    public Edit(update: Preset): void
    {
        const preset = this.Presets.Find(p => p.Name === update.Name);
        if (preset)
        {
            preset.Width = update.Width;
            preset.Height = update.Height;
            preset.Brightness = update.Brightness;
            preset.Contrast = update.Contrast;
            preset.Rotation = update.Rotation;
            
            this._storage.Update(this.Presets.Items);
        }
    }
}
